import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './comps/App';
// import { HashRouter, Routes, Route } from 'react-router-dom';
import { HashRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HashRouter>
      {/* <Routes>
        <Route path="/" element={ <App /> }>
        </Route>
      </Routes> */}
      <App />
    </HashRouter>
  </React.StrictMode>
);
